import { InputAdornment, IconButton } from "@mui/material";
import { alpha } from "@mui/material";
import ClearIcon from "@mui/icons-material/Clear";

export function ClearButton({
  onClick,
  disabled = false,
}: {
  onClick: () => void;
  disabled?: boolean;
}) {
  return (
    <InputAdornment position="end" sx={{ ml: 0.5, mr: 0.5 }}>
      <IconButton
        size="small"
        onClick={onClick}
        disabled={disabled}
        sx={{
          p: 0.5,
          color: "text.secondary",
          "&:hover": {
            backgroundColor: (theme) =>
              alpha(theme.palette.text.secondary, 0.04),
          },
        }}
      >
        <ClearIcon sx={{ fontSize: "1rem" }} />
      </IconButton>
    </InputAdornment>
  );
}
